import pick from 'lodash/pick';

import * as TrackerEvents from '../config/tracker-events';

const trackerGenerator = {
  computed: {
    defaultPayload() {
      return {
        source: this.$root.source,
        referrer: this.$root.referrer,
        ui: window.USER.id36,
        session: this.$root.mixinSessionId,
        session_id: this.$root.mixinSessionId,
      };
    },
  },
  methods: {
    mixinSendTracker(eventName, additionalPayload = {}) {
      return this.$tracker.event(this[eventName](additionalPayload));
    },

    // don't call these methods, use `sendTracker` instead
    generator({trackerRequirementFields, additionalPayload} = {}, eventName) {
      return pick({...this.defaultPayload, ...additionalPayload, evn: eventName}, trackerRequirementFields);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_BANNER_VIEW](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session', 'banner_name', 'banner_url', 'banner_position'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_BANNER_VIEW);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_BANNER_CLICK](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session', 'banner_name', 'banner_url', 'banner_position'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_BANNER_CLICK);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ICON_COUPON_CLICK](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ICON_COUPON_CLICK);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_CLOSE](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session', 'announcement_title'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_CLOSE);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_IMPRESSION](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session', 'announcement_title', 'show_more', 'closable'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_IMPRESSION);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_SHOW_MORE](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session', 'announcement_title'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_SHOW_MORE);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_BANNER_SECONDARY_CLICK](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session', 'banner_name', 'banner_url', 'banner_position'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_BANNER_SECONDARY_CLICK);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_BANNER_SECONDARY_VIEW](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session', 'banner_name', 'banner_url', 'banner_position'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_BANNER_SECONDARY_VIEW);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_MERCHANT_COURSES](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_MERCHANT_COURSES);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_TNC](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_TNC);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_CONFIRMATION](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id', 'success_prakerja_count', 'failed_prakerja_count'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_CONFIRMATION);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_SUCCESS](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_SUCCESS);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_SEARCH](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id', 'keyword', 'any_result'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_SEARCH);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_OTP](additionalPayload) {
      const trackerRequirementFields = [
        'evn',
        'source',
        'referrer',
        'ui',
        'session_id',
        'otp_try_count',
        'otp_success_count',
        'otp_failed_count',
      ];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_OTP);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_CATEGORY](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id', 'category', 'any_result'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_CATEGORY);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ONBOARDING_VIEW](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ONBOARDING_VIEW);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ONBOARDING_CLOSE](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_ONBOARDING_CLOSE);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_LANDING_PAGE_VIEW](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'deep_scroll'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_LANDING_PAGE_VIEW);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_KELAS_TERDEKAT_FILTER_CLICK](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'session', 'ui', 'course_type', 'course_timeframe'];
      return this.generator(
        {trackerRequirementFields, additionalPayload},
        TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_KELAS_TERDEKAT_FILTER_CLICK
      );
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_KELAS_TERDEKAT_PAGE_VIEW](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session'];
      return this.generator(
        {trackerRequirementFields, additionalPayload},
        TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_KELAS_TERDEKAT_PAGE_VIEW
      );
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_COUPON_LIST](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session', 'action', 'voucher_code', 'sku_name', 'invoice_id'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_COUPON_LIST);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_ENTRYPOINT](additionalPayload) {
      const trackerRequirementFields = ['evn', 'ui', 'session_id', 'source', 'action'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_ENTRYPOINT);
    },
    [TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_PAGE](additionalPayload) {
      const trackerRequirementFields = ['evn', 'ui', 'session_id', 'source', 'action'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_PRAKERJA_GAMIFICATION_PAGE);
    },
  },
};

export default trackerGenerator;
